import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const links = [
    { to: '/shop', label: 'SHOP' },
    { to: '/supplies', label: 'SUPPLIES' },
    { to: '/about', label: 'ABOUT' },
    { to: '/faq', label: 'FAQ' },
    { to: 'mailto:vialratpayments@gmail.com', label: 'CONTACT', external: true },
    { to: '/faq', label: 'SHIPPING' },
    { to: '/faq', label: 'POLICIES' },
  ];
  return (
    <footer className="mt-24 border-t border-white/5 bg-[#0a0a0b]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <h3 className="font-serif-display text-3xl md:text-4xl text-gradient-pink tracking-tight">VIAL RAT RESEARCH CO.</h3>
        <div className="mt-6 flex flex-wrap gap-x-6 gap-y-3">
          {links.map(l => (
            l.external
              ? <a key={l.label} href={l.to} className="font-mono-label text-[11px] text-neutral-400 hover:text-[#ff2fa1] transition-colors">{l.label}</a>
              : <Link key={l.label} to={l.to} className="font-mono-label text-[11px] text-neutral-400 hover:text-[#ff2fa1] transition-colors">{l.label}</Link>
          ))}
        </div>
        <div className="mt-10 max-w-3xl">
          <div className="h-px w-full bg-gradient-to-r from-[#ff2fa1]/70 via-white/10 to-transparent" />
        </div>
        <div className="mt-8 max-w-2xl">
          <div className="font-mono-label text-[11px] text-[#ff2fa1] mb-3">FOR RESEARCH USE ONLY</div>
          <p className="text-sm text-neutral-400 leading-relaxed">
            Products are intended for laboratory and research purposes only. Nothing sold here is intended to diagnose, treat, cure or prevent any condition.
          </p>
          <div className="mt-6 font-mono-label text-[11px] text-neutral-500">CANADA</div>
          <div className="mt-1 font-mono-label text-[11px] text-neutral-500">© 2026 VIAL RAT RESEARCH CO.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
